/* Presentation-only browser reminder. Never grants access or verifies an account. */
(function () {
 'use strict';
 const configNode=document.getElementById('BanditosActivationConfig');
 if(!configNode)return;
 let config;try{config=JSON.parse(configNode.textContent);}catch{return;}
 const key='banditos:activation-reminder:v1';
 const read=()=>{try{return localStorage.getItem(key)==='pending';}catch{return false;}};
 const clear=()=>{try{localStorage.removeItem(key);}catch{}};
 const save=()=>{try{localStorage.setItem(key,'pending');}catch{}};
 if(config.authenticated){clear();return;}
 const confirmed=document.querySelector('[data-banditos-activation-confirmed]');
 const retry=new URLSearchParams(location.search).get('retry')==='1';
 if(confirmed)save();
 else if(retry)clear();
 const form=document.querySelector('.banditos-register-page .create-customer-form');
 const template=document.getElementById('BanditosActivationReminder');
 let reminder=null;
 function render(){
  if(!form||!template||confirmed)return;
  const hasErrors=!!form.querySelector('.form-message');
  const show=read()&&!hasErrors;
  if(show&&!reminder){
   reminder=template.content.firstElementChild.cloneNode(true);
   form.before(reminder);
  }
  form.hidden=show;
  if(reminder)reminder.hidden=!show;
 }
 render();
 document.addEventListener('click',function(event){
  const target=event.target instanceof Element?event.target:null;
  if(!target)return;
  if(target.closest('[data-activation-retry]')){clear();return;}
  const account=target.closest('[data-open-auth-sidebar],.header__link--account.customer_login_link');
  if(account&&read()&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey&&!event.altKey){
   event.preventDefault();event.stopImmediatePropagation();
   location.assign(config.registerUrl);
  }
 },true);
 window.addEventListener('storage',render);
 window.addEventListener('pageshow',render);
})();
